module.exports = __webpack_public_path__ + "static/media/images_upload_icon.83b3931f.svg";